export const API_URL = {
  subjectArea: '/subjectArea',
  gptDataset: '/gpt-datasets',
  layout: '/layout',
  kpi: '/kpi',
  kpiCard: '/kpi-card',
  favorite: '/favorite',
  myInsights: '/my-insights',
  chatbotUseCases: '/chatbot/use-case',
  dashboard: '/dashboard',
  branding: '/branding',
  brandingCustomizations: '/brandingCustomization',
  brandingCustomizationValues: '/brandingCustomizationValue',
  applicationSetting: '/applicationSetting',
  dataApiDimensions: '/dimensions',
  dataApiMetric: '/metrics',
  dataApiFilters: '/filter',
  dataApiCache: '/caching',
  dataApiShouldRefresh: '/should-refresh',
  dataApiDataSourceNames: '/data-sources/names',
  metricsNames: '/names',
  dimensionsNames: '/names',
  filtersNames: '/names',
  filters: '/filters',
  filtersGroup: '/globalFilterGroup',
  filtersDimension: '/filtersDimension',
  filtersName: '/getFiltersName',
  shouldLogin: '/should-login',
  userSettings: '/userSettings',
  mailEmotion: '/mailEmotion',
  region: '/region',
  landing: '/landing',
  landingItem: '/landingItem',
};

export const SECURITY_API_URL = {
  auth: '/auth/authorize',
  refresh: '/auth/refresh',
  logout: '/auth/logout',
  status: '/auth/me/status',
  deviceStart: '/auth/device/start',
  devicePoll: '/auth/device/poll',
  deviceToken: '/auth/device/token',
  passkeyLoginOptions: '/auth/passkey/login/options',
  passkeyLoginVerify: '/auth/passkey/login/verify',
  passkeyRegisterOptions: '/auth/passkey/register/options',
  passkeyRegisterVerify: '/auth/passkey/register/verify',
};

export const AUTH_URLS = [
  SECURITY_API_URL.auth,
  SECURITY_API_URL.refresh,
  SECURITY_API_URL.logout,
  SECURITY_API_URL.status,
  SECURITY_API_URL.deviceStart,
  SECURITY_API_URL.devicePoll,
  SECURITY_API_URL.deviceToken,
  SECURITY_API_URL.passkeyLoginOptions,
  SECURITY_API_URL.passkeyLoginVerify,
  SECURITY_API_URL.passkeyRegisterOptions,
  SECURITY_API_URL.passkeyRegisterVerify,
];
